(() => {
  if (customElements.get('km-recently-viewed')) return;
  customElements.define('km-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized || !this.dataset.productId) return;
      this.initialized = true;
      const currentId = this.dataset.productId;
      let ids = [];
      try {
        const stored = JSON.parse(localStorage.getItem('kmRecentlyViewedProducts') || localStorage.getItem('viewedProducts') || '[]');
        if (Array.isArray(stored)) ids = [...new Set(stored.map(String).filter(id => /^\d+$/.test(id) && id !== currentId))];
        localStorage.setItem('kmRecentlyViewedProducts', JSON.stringify([currentId, ...ids].slice(0, 12)));
      } catch { /* Storage can be unavailable in private or restricted browsing. */ }
      ids = ids.slice(0, 5);
      if (!ids.length) return;
      try {
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('section_id', 'km-recently-viewed');
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', ids.map(id => `id:${id}`).join(' OR '));
        const response = await fetch(url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = this.querySelector('[data-recent-products]');
        ids.forEach(id => {
          const card = doc.querySelector(`[data-recent-product-id="${id}"]`);
          if (card) grid.append(card);
        });
        this.hidden = !grid.children.length;
      } catch { /* Keep the section hidden if products cannot be loaded. */ }
    }
  });
})();
